module.exports = __webpack_public_path__ + "static/media/profile.d8e40d79.png";